import axios from 'axios';
import {API} from "@/services/url";

/**
 * One-page client onboarding (Tipsoi Device Portal project + HRM office + admin login).
 *
 * Note the guarded error handling: the backend returns a plain `{message}` body for business
 * failures, but a network/CORS/timeout error has no `e.response` at all, and reading
 * `e.response.data.message` blindly (as most services here do) throws a TypeError that hides the
 * real problem. Every callback below falls back to a readable string instead.
 */
export default {
	/**
	 * Success callback receives the whole response body — the handover card needs `projectCode`,
	 * `projectId`, `officeId` and `warnings`, so nothing may be narrowed to a single field here.
	 */
	createClient: function (data, success, error) {
		axios.post(API.onboarding.client, data)
			.then(r => success(r.data))
			.catch(e => error(readError(e, 'Could not create the client')));
	},

	/**
	 * Reports whether an admin email is still free. Reads `available` — NOT `message`, which the
	 * backend's InovaceSays.ok() overwrites with "Success" on every 200 response.
	 */
	checkEmailAvailable: function (email, success, error) {
		axios.get(API.onboarding.emailAvailable, {params: {email: email}})
			.then(r => success(r.data && r.data.available === true))
			.catch(e => error(readError(e, 'Could not check the email')));
	}
};

function readError(e, fallback) {
	if (e && e.response && e.response.data && e.response.data.message) {
		return e.response.data.message;
	}
	if (e && e.message) return e.message;
	return fallback;
}
